export default "__VITE_ASSET__Cth8HAsd__"